import { SelectField, SelectFieldProps } from "matsuri-ui"

// 指定されたindexの前と後を丸ごと入れ替える
const swap = <T,>(arr: T[], index: number) => {
    return [...arr.slice(index), ...arr.slice(0, index)]
}

export const getTimeOptions = (props: {
    min?: string
    max?: string
    swapAt?: number
}) => {
    return swap(
        Array.from({ length: 24 }, (_, i) => {
            const hour = (i + 1).toString().padStart(2, "0")
            return {
                label: `${hour}:00`,
                value: `${hour}:00`
            }
        }),
        // 0時が先頭にきても何も嬉しくないので、省略されたら適当に朝の時間を先頭にする
        props.swapAt ?? 8
    )
        .filter(({ value }) => (props.min ? value > props.min : true))
        .filter(({ value }) => (props.max ? value < props.max : true))
}

export const TimeField = ({
    ...props
}: SelectFieldProps & {
    min?: string
    max?: string
}) => {
    return (
        <SelectField
            {...props}
            options={getTimeOptions({
                min: props.min,
                max: props.max
            })}
        />
    )
}
